// extracted by mini-css-extract-plugin
export default {"tableStyle":"Wv7WiiG"};